import { render, staticRenderFns } from "./modal-task-copy.vue?vue&type=template&id=b9ee6d8a&scoped=true&"
import script from "./modal-task-copy.vue?vue&type=script&lang=ts&"
export * from "./modal-task-copy.vue?vue&type=script&lang=ts&"
import style0 from "./modal-task-copy.vue?vue&type=style&index=0&id=b9ee6d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ee6d8a",
  null
  
)

export default component.exports